import { CSSObject } from '@chakra-ui/react';
import errorBg from '@/assets/buffalobet/images/backgrounds/onboarding_bg.jpg';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: 'center',
  minH: '100dvh',
  bg: `url(${errorBg}) center/cover no-repeat`,
};

export const CenterWrapper: CSSObject = {
  alignItems: 'center',
  color: 'white',
  gap: '0',
  h: undefined,
  justifyContent: 'center',
  maxW: '500px',
  mb: [null, null, '12'],
  minH: [null, null, '480px'],
  mt: ['0', null, '12'],
  mx: 'auto',
  pos: 'relative',
  px: ['4', null, '0'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
  w: 'full',
  zIndex: '1',

  _before: {
    content: '""',
    h: '275px',
    left: '0',
    pos: 'absolute',
    top: '0',
    w: 'full',
    zIndex: '-1',
  },
};

export const ContentHeadingText: CSSObject = {
  color: 'white',
  fontFamily: 'accent',
  fontSize: '4xl',
  lineHeight: 'none',
  mb: '2.5',
  mt: '4',
  textShadow: '0px 0px 8px rgba(67, 187, 255, 0.50)',
  textTransform: 'uppercase',
};

export const ContentBodyText: CSSObject = {
  fontSize: 'md',
  mb: '4',
  textAlign: 'center',
  color: 'white',
  fontWeight: 'semibold',
  width: 'full',
  ml: '0',

  '.chakra-link': {
    fontWeight: 'bold',
    color: 'beta.500',
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  mt: '4',
  fontWeight: 'normal',
};

export const RegistrationContent: CSSObject = {
  fontWeight: 'normal',
  '.chakra-link': {
    textDecoration: 'none',
  },
};
